import React from "react";

/**
 * Lists `children` with fragments, at any depth, replaced by their own
 * children. Drops `null`, `undefined`, and booleans.
 */
export const flattenChildren = (
  children: React.ReactNode
): React.ReactNode[] => {
  const flattened: React.ReactNode[] = [];

  React.Children.forEach(children, (child) => {
    if (isFragment(child)) {
      flattened.push(...flattenChildren(child.props.children));
      return;
    }
    if (child === null || child === undefined) {
      return;
    }
    flattened.push(child);
  });

  return flattened;
};

const isFragment = (
  node: React.ReactNode
): node is React.ReactElement<React.FragmentProps> =>
  React.isValidElement(node) && node.type === React.Fragment;
